module.exports = __webpack_public_path__ + "static/media/image-2.d24de886.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Weather/image-2.png
// module id = 292
// module chunks = 0